import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { H6, P } from "../../../AbstractElements";
import { CommonLinksTitle, Href } from "../../../Constants/Constants";
import { CommonLinksData, CommonLinksSubTitle } from "../../../Data/UiKits/NavigateLinks";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const CommonLinks = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={CommonLinksTitle} span={CommonLinksSubTitle} />
        <CardBody>
          <Row className="g-3">
            {CommonLinksData.map((item, index) => (
              <Col sm="6" xxl="3" key={index}>
                <div className="card-wrapper border rounded-3 h-100">
                  <H6 className="sub-title">{item.title}</H6>
                  <div className={item.class}>
                    {item.links.map((data, index) => (
                      <P key={index}>
                        <Link className={data.class} to={Href}>
                          {data.text}
                        </Link>
                      </P>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CommonLinks;
